/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectDataKey, ProjectDataState } from './project-data-reducer';

export const selectProjectDataState = createFeatureSelector<ProjectDataState>(ProjectDataKey);

export const selectParamCategories = createSelector(selectProjectDataState, (state) => state.paramCategory);

export const selectAddProjectParameterData = createSelector(selectProjectDataState, (state) => state.initialData);

export const selectBuiltInProjectParameter = createSelector(
  selectProjectDataState,
  (state) => state.builtInGroupDataPramsInfo
);

export const selectDefinitionGroupProjectParameter = createSelector(
  selectProjectDataState,
  (state) => state.definitionGroupPramsInfo
);
